"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupChatInfoSocketUpdateObservable = void 0;
const mappers_1 = require("../../mappers");
const socket_1 = require("../../socket");
const Observable_1 = require("../../socket/Observable");
const DomainEvents_1 = require("../../utils/DomainEvents");
const utils_1 = require("../../utils");
class GroupChatInfoSocketUpdateObservable {
    constructor(chatsStorage, httpAdapter, organizationUser, socketAdapter, userDirectory) {
        this.chatsStorage = chatsStorage;
        this.httpAdapter = httpAdapter;
        this.organizationUser = organizationUser;
        this.organization = organizationUser.getOrganization();
        this.socketAdapter = socketAdapter;
        this.userDirectory = userDirectory;
    }
    chatInfoUpdateListener(cb, groupType) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getEventKey)(socket_1.DomainEvents.UPDATE_CHAT_LIST_ITEM, this.organization.organizationId), (data) => {
            const groupHasChat = this.getChats(groupType).chats.some(chat => chat.groupInfo.id === data.info._id);
            if (groupHasChat) {
                const groupInfo = data.info;
                const updatedGroupInfo = (0, mappers_1.groupInfoMapper)(groupInfo, this.userDirectory, this.organizationUser, this.httpAdapter, this.socketAdapter);
                this.updateGroupInfo(cb, updatedGroupInfo, groupType);
            }
        });
    }
    updateGroupInfo(cb, updatedGroupInfo, groupType) {
        let chatList = this.getChats(groupType);
        let chatListItem = chatList.chats.find(chat => chat.groupInfo.id === updatedGroupInfo.id);
        if (chatListItem) {
            chatListItem = Object.assign(Object.assign({}, chatListItem), { groupInfo: updatedGroupInfo });
            const updatedChats = chatList.chats.map(chat => chat.id === chatListItem.id ? Object.assign(Object.assign({}, chat), chatListItem) : chat);
            chatList = Object.assign(Object.assign({}, chatList), { chats: updatedChats });
            this.setChats(chatList, groupType);
            cb(chatList);
        }
    }
    getChats(groupType) {
        return this.chatsStorage.getChatListByType(groupType);
    }
    setChats(chatList, groupType) {
        this.chatsStorage.setChatListByType(groupType, chatList);
    }
    muteNotifications(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.httpAdapter.getChatAdapter().muteNotifications(data);
            }
            catch (e) {
                throw new utils_1.HhnException(e);
            }
        });
    }
    updateVisibleToPatient(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.httpAdapter.getChatAdapter().updateVisibleToPatient(data);
            }
            catch (e) {
                throw new utils_1.HhnException(e);
            }
        });
    }
    updateVisibleToPhysician(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.httpAdapter.getChatAdapter().updateVisibleToPhysician(data);
            }
            catch (e) {
                throw new utils_1.HhnException(e);
            }
        });
    }
    leaveAndDeleteGroup(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.httpAdapter.getChatAdapter().leaveAndDeleteGroup(data);
            }
            catch (e) {
                throw new utils_1.HhnException(e);
            }
        });
    }
}
exports.GroupChatInfoSocketUpdateObservable = GroupChatInfoSocketUpdateObservable;
